export default "/_next/static/images/8043b9475842dd15a877f83dbc35d669.jpg";